import { EntreprisesBySiren } from "@src/store/store.definition";
import { useEntreprises } from "@src/store/store.entreprise";
import { useMe } from "@src/store/store.me";

export function estRenouvellementOffert(
  entreprisesBySiren: EntreprisesBySiren | undefined
): boolean {
  const entreprises = Object.values(entreprisesBySiren ?? {});
  return (
    entreprises.length > 0 &&
    entreprises.every((entreprise) => entreprise.renouvellementOffert === true)
  );
}

export function useRenouvellementOffert(): boolean {
  const { me } = useMe();
  const { entreprisesBySiren } = useEntreprises(
    me?.entreprisePrincipale.millesimeActuel
  );
  return estRenouvellementOffert(entreprisesBySiren);
}
